/**
 * Publishes user edits made in Swagger Editor to both the editor window and
 * its embedding page. Consumers can listen for `swagger-editor:spec-changed`.
 */
const SpecChangeEventsPlugin = () => ({
  statePlugins: {
    editor: {
      wrapActions: {
        setContent: (originalAction, system) => (content, origin) => {
          const result = originalAction(content, origin)

          if (origin === system.EditorContentOrigin?.Editor) {
            const detail = { type: 'swagger-editor:spec-changed', spec: content }
            window.dispatchEvent(new CustomEvent(detail.type, { detail }))
            window.parent?.postMessage(detail, window.location.origin)
          }

          return result
        },
      },
    },
  },
})

export default SpecChangeEventsPlugin
